import Connections from '../../connections';
import {
  action, observable, toJS
} from 'mobx';
import {
  createEvent, getEvent, getEventById, updateEvent,
} from '../../axios/eventsRequests';
import {
  uploadSingleImage,
  uploadImages,
  imageProgresses,
} from '../../helperFunctions/uploadService';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  isImageArray,
} from '../storeInterfaces/featuredArticlesStore';
import { Image } from '../storeInterfaces/eventsInterface';
import { RequestStatus } from 'mobx-store';

export class EventStore {
  @observable eventList: any[] = [];

  @observable failedImages: File[] = [];

  @observable imagesProgresses: {[x: string]: imageProgresses} = {};

  @observable isAlertOpened: boolean = false;

  @observable selectedEvent = {

  };

  @observable loading = false;

  @observable getEventsRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getEvent(countries: ICountry[]): Promise<void> {
    try {
      this.loading = true;
      this.getEventsRequestStatus = RequestStatus.LOADING;
      const countriesIsoCode = countries.map((country: ICountry) => country.isoCode);
      const availableCountries = countriesIsoCode.toString();

      const response = await Connections.wadiDeglaAxios.httpGet(`${getEvent}?availableCountries=${availableCountries}`);
      this.eventList = response.data;
      this.loading = false;
      this.getEventsRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getEventsRequestStatus = RequestStatus.FAILED;
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }
  @action.bound
  public async handleProgress(progress: {[x:string]: imageProgresses}){
    if(progress){
      this.imagesProgresses = {...toJS(this.imagesProgresses), ...progress}
    }
  }
  @action
  public async filterEvent(query: string): Promise<void> {
    try {
      this.loading = true;
      const config = {
        params: {
          query,
        },
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getEvent, config);
      this.eventList = response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getEventById(id: number): Promise<void> {
    try {
      this.loading = true;
      const {
        data,
      } = await Connections.wadiDeglaAxios.httpGet(getEventById(id));

      const restructuredEvent = this.restructureEvent(data);

      this.selectedEvent = restructuredEvent;

    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createEvent(newEvent: any): Promise<number> {
    try {
      if (isImageArray(newEvent.imageURL)) {
        newEvent.imageURL = await uploadSingleImage(newEvent.imageURL,this.handleProgress);
      }
      const images = await uploadImages(newEvent.images, (failedFiles) => {
        this.onUploadingImagesFail(failedFiles);
      },this.handleProgress);
      newEvent.startDate = new Date(newEvent.startDate).getTime();
      newEvent.images = images;
      newEvent.endDate = newEvent.endDate ? new Date(newEvent.endDate).getTime() : null;
      const response = await Connections.wadiDeglaAxios.httpPost(createEvent, newEvent);
      return response.data.eventId;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updateEvent(updatedEvent: any, eventId: number, initGallery: Image[]): Promise<void> {
    try {

      if (isImageArray(updatedEvent.imageURL)) {
        updatedEvent.imageURL = await uploadSingleImage(updatedEvent.imageURL,this.handleProgress);
      }
      updatedEvent.startDate = new Date(updatedEvent.startDate).getTime();
      updatedEvent.endDate = updatedEvent.endDate ? new Date(updatedEvent.endDate).getTime() : null;
      
      const deletedImagesIds: number[] = [];
      const newImages: any[] = [];
      for (const image of updatedEvent.images) {
        if (image.preview) {
          newImages.push(image);
        } else {
          const findIndex = initGallery.findIndex((media) => media.key === image.key);
          if (findIndex !== -1) {
            initGallery.splice(findIndex, 1);
          }
        }
      }
      for (const image of initGallery) {
        deletedImagesIds.push(image.key);
      }
      const images = await uploadImages(newImages, (failedFiles) => {
        this.onUploadingImagesFail(failedFiles);
      },this.handleProgress);
      updatedEvent.newImages = images;
      updatedEvent.deletedImagesIds = deletedImagesIds;
      delete updatedEvent.images;
      await Connections.wadiDeglaAxios.httpPut(updateEvent(eventId), updatedEvent);
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  private onUploadingImagesFail (files: any[]) {   
    this.failedImages = files; 
    this.isAlertOpened = true;
  } 

  @action onDismissAlert = () => {
    this.isAlertOpened = false;
    this.failedImages = [];
  }


  private restructureEvent (eventData: any) {
    let {
      imageURL,
      startDate,
      title,
      description,
      endDate,
      eventCategory,
      isAllDay,
      isActive,
      eventImages,
    } = eventData;

    imageURL = imageURL ? [{
      imageUrl: imageURL,
    }] : [];
    startDate = startDate ? new Date(Number(startDate)) : null;
    endDate = endDate ? new Date(Number(endDate)) : null;
    const eventCategoryId = eventCategory ? eventCategory.eventCategoryId : null;

    const images = eventImages.map((image: any) => {
      return {
        key: image.gallery.imageId,
        imageUrl: image.gallery.imageURL,
      };
    });

    return {
      imageURL,
      startDate,
      title,
      description,
      endDate,
      eventCategory,
      isAllDay,
      isActive,
      eventCategoryId,
      images,
    };
  }
}
